<ng-container *ngIf="loaded; else loading">
    <div class="appointment" *ngIf="appointment; else noAppointments">
        <ng-container *ngIf="appointment.netwerk_id !== 'NONE'; else noAppointments">
            <ins-appointment-booking-container
                class="appointment_creation"
                *ngIf="appointment.btn_afspraakmaken"
                [appointment]="appointment"
                [file_serial_number]="file_serial_number"
            ></ins-appointment-booking-container>
            <ins-appointment-overview
                class="appointment__overview"
                *ngIf="!appointment.btn_afspraakmaken"
                [appointment]="appointment"
            ></ins-appointment-overview>
        </ng-container>
    </div>
</ng-container>

<ng-template #noAppointments>
    <div class="appointment__empty">
        <p>De map is leeg, omdat deze informatie voor uw claim niet nodig is.</p>
    </div>
</ng-template>

<ng-template #loading>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
</ng-template>
